




































import Vue, { PropType } from 'vue';
import { CorporateContent, Milestones } from '@/types';
import { Phases, EventType } from '@/constants';
import { getPhaseCompletionStatus } from '@/util';
import { BuildStageDates, OwnStageDates } from '../../services/service';

export default Vue.extend({
  props: {
    content: {
      type: Object as PropType<CorporateContent>
    },
    step: {
      type: Object as PropType<Milestones>
    },
    stage: {
      type: String,
      required: true
    },
    surverySteps: {
      type: Array as PropType<string[]>,
      required: true
    }
  },
  data () {
    return {
      close: false,
      imageBaseurl: process.env.VUE_APP_IMAGE_URL,
      EventType
    }
  },
  computed: {
    stageDate (): string {
      const key = this.stage === Phases.Build ? (BuildStageDates as any)[this.step.keyName] : this.stage === Phases.Own ? (OwnStageDates as any)[this.step.keyName] : '';
      const date = key ? (this.step as any)[key] : '';
      return date ? this.formatDate(date) : '';
    },
    isSurveryStep (): boolean {
      return this.surverySteps.some(x => this.step.name.trim().replace(/\s/g, '-').toLowerCase() === x.toLowerCase());
    },
    stageStatus (): string {
      return this.isSurveryStep ? 'remtick' : this.step.status?.stage ? getPhaseCompletionStatus(this.step.status.stage) : '';
    },
    showCompletionDate (): boolean {
      return this.stageStatus === 'completed' && !this.isSurveryStep;
    }
  },
  methods: {
    getImageSource (imagePath: string): string {
      const step = this.step.name.toLowerCase()
      if ([Phases.Design.toLowerCase(), Phases.Plan.toLowerCase(), Phases.Finance.toLowerCase()].includes(step)) {
        return `${location.origin}${imagePath}`;
      }
      return `${this.imageBaseurl}${imagePath}`;
    },
    handleImageError (event: Event) {
      (event.target as HTMLImageElement).src = require('@/assets/images/defaultHome.png')
    },
    formatDate (date: string) {
      const d = date.split('-');
      return d[1] + '/' + d[2] + '/' + d[0];
    }
  }
});
